/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'license-delete-dialog';
const prefix = `${moduleName}.${componentName}`;

export const deleteLicensesHeader = `${prefix}.deleteLicensesHeader`;
export const singleLicenseDeleteMessage = `${prefix}.singleLicenseDeleteMessage`;
export const severalLicenseDeleteMessage = `${prefix}.severalLicenseDeleteMessage`;
export const deleteConfirmMessage = `${prefix}.deleteConfirmMessage`;
export const deleteBtnLabel = `${prefix}.deleteBtnLabel`;
export const columnTitleType = `${prefix}.columnTitleType`;
export const columnTitleLicenseId = `${prefix}.columnTitleLicenseId`;
export const columnTitleServiceUnits = `${prefix}.columnTitleServiceUnits`;
export const columnTitleExpiry = `${prefix}.columnTitleExpiry`;
export const expiredLabel = `${prefix}.expiredLabel`;

export const ENGLISH = {
    [deleteLicensesHeader]: 'Delete License(s)',
    [singleLicenseDeleteMessage]: 'You are about to delete the following license:',
    [severalLicenseDeleteMessage]: 'You are about to delete the following licenses:',
    [deleteConfirmMessage]: 'This action cannot be undone. Are you sure you want to continue?',
    [deleteBtnLabel]: 'Delete',
    [columnTitleType]: 'Type',
    [columnTitleLicenseId]: 'License ID',
    [columnTitleServiceUnits]: 'Service Units',
    [columnTitleExpiry]: 'Expiry',
    [expiredLabel]: 'Expired',
};
